var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"w-full mx--auto"},[_c('thead',{staticClass:"text-xl border-t border-b-2 text-output-primary border-output-primary"},[_c('tr',_vm._l((_vm.tables.headers),function(header,index){return _c('th',{key:index,staticClass:"p-3"},[_vm._v(" "+_vm._s(header.title)+" ")])}),0)]),_c('tbody',{staticClass:"text-lg text-output-primary"},_vm._l((_vm.tables.data),function(tableData,tableIndex){return _c('tr',{key:tableIndex,class:[
                ' border-output-primary',
                {
                    'border-b': _vm.tables.data.length !== tableIndex + 1,
                    ' border-b-2': _vm.tables.data.length === tableIndex + 1
                }
            ]},_vm._l((tableData),function(cellData,cellIndex){return _c('td',{key:cellIndex,class:[
                    ' font-semibold text-center',
                    {
                        'p-3': !_vm.isCpc,
                        'p-2': _vm.isCpc
                    }
                ],attrs:{"colspan":_vm.colSpanLength(tableData.length)}},[_vm._v(" "+_vm._s(_vm.cellContent(cellData, cellIndex))+" ")])}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }